import {DigitInput} from '../digit-input';
import {RegularExp} from '../forms/consts/consts';
import {Api, Method, SuccessHTTPStatusRange} from '../api/api';
import {ButtonTitle, ClassName, CodeTextContent, FormStatus, Selector} from './constants';

class StockForm {
  #stockFormWrapperElement;
  #digitsWrapperElement;
  #formElement;
  #emailInputElement;
  #textContentElement;
  #titleElement;
  #textElement;

  #submitButton;

  #actionUrl;

  #status = FormStatus.SEND_EMAIL;

  #customFetch = new Api();

  #digitInputView;

  constructor() {
    this.#stockFormWrapperElement = document.querySelector(Selector.FORM_WRAPPER);

    if (!this.#stockFormWrapperElement) return;

    this.#formElement = this.#stockFormWrapperElement.querySelector(Selector.FORM);
    this.#digitsWrapperElement = this.#formElement.querySelector(Selector.DIGITS_WRAPPER);
    this.#submitButton = this.#formElement.querySelector(Selector.SUBMIT_BUTTON);
    this.#emailInputElement = this.#formElement.querySelector(Selector.EMAIL_INPUT);
    this.#textContentElement = this.#stockFormWrapperElement.querySelector(Selector.TEXT_CONTENT_WRAPPER);
    this.#titleElement = this.#stockFormWrapperElement.querySelector(Selector.TITLE);
    this.#textElement = this.#stockFormWrapperElement.querySelector(Selector.TEXT);

    this.onSubmitButtonMouseover = this.onSubmitButtonMouseover.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.#actionUrl = this.#formElement.action;
    this.#digitInputView = new DigitInput(this.#digitsWrapperElement);

    this.#addEvents();
  }

  #addEvents() {
    this.#formElement.addEventListener(`change`, this.onFormChange);
    this.#formElement.addEventListener(`submit`, this.onFormSubmit);
    this.#submitButton.addEventListener(`mouseover`, this.onSubmitButtonMouseover);
  }

  #isMailValidated() {
    return this.#emailInputElement.value.match(RegularExp.EMAIL) !== null
  }

  #showMailError() {
    if (this.#emailInputElement.classList.contains(ClassName.INPUT_ERROR)) return;

    this.#emailInputElement.classList.add(ClassName.INPUT_ERROR);
  }

  #hideMailError() {
    if (!this.#emailInputElement.classList.contains(ClassName.INPUT_ERROR)) return;

    this.#emailInputElement.classList.remove(ClassName.INPUT_ERROR);
  }

  #showDigitWrapperError() {
    if (this.#digitsWrapperElement.classList.contains(ClassName.DIGITS_WRAPPER_ERROR)) return;

    this.#digitsWrapperElement.classList.add(ClassName.DIGITS_WRAPPER_ERROR);
  }

  #hideDigitWrapperError() {
    if (!this.#digitsWrapperElement.classList.contains(ClassName.DIGITS_WRAPPER_ERROR)) return;

    this.#digitsWrapperElement.classList.remove(ClassName.DIGITS_WRAPPER_ERROR);
  }

  #changeSubmitButtonTitle() {
    this.#submitButton.querySelector(Selector.SUBMIT_BUTTON_TEXT).textContent = ButtonTitle[this.#status];
  }

  #getFormData(isCode) {
    const formData = new FormData(this.#formElement);

    if (isCode) {
      formData.set(`code`, this.#digitInputView.code);
    }

    return formData;
  }

  #showDigitsWrapper() {
    this.#digitsWrapperElement.classList.remove(ClassName.DIGITS_WRAPPER_HIDE);
  }

  #hideEmailInput() {
    this.#emailInputElement.classList.add(ClassName.EMAIL_INPUT_HIDE);
  }

  #hideForm() {
    this.#formElement.classList.add(ClassName.FORM_HIDE);
    this.#textContentElement.classList.add(ClassName.TEXT_CONTENT_HIDE);
  }

  /**
   * Смена текста
   */
  #changeTextContent(titleText, text) {
    console.log(titleText, text);
    this.#titleElement.textContent = titleText;
    this.#textElement.textContent = text;
  }

  #enableSendCode() {
    this.#stockFormWrapperElement.classList.add(ClassName.SEND_CODE);
    this.#textContentElement.classList.add(ClassName.TEXT_CONTENT_SEND_CODE);
  }

  #enableErrorAnswer(titleText, text) {
    this.#textContentElement.classList.remove(ClassName.TEXT_CONTENT_SEND_CODE);
    this.#titleElement.classList.remove(ClassName.TITLE_SUCCESS);
    this.#titleElement.classList.add(ClassName.TITLE_ERROR);
    this.#changeTextContent(titleText, text);
  }

  #enableSuccessAnswer(titleText, text) {
    this.#textContentElement.classList.remove(ClassName.TEXT_CONTENT_SEND_CODE);
    this.#titleElement.classList.remove(ClassName.TITLE_ERROR);
    this.#titleElement.classList.add(ClassName.TITLE_SUCCESS);
    this.#changeTextContent(titleText, text);
  }

  /**
   * Отлавливает ошибку запроса к серверу
   *
   * @param {Error} e
   */
  #errorHandler(e) {
    console.log(e);
    this.#enableErrorAnswer(CodeTextContent.ERROR_TITLE, CodeTextContent.SERVER_ERROR_TEXT);
  }

  /**
   * Выводит сообщение об ошибки пришедшей с сервера
   *
   * @param {number} code - кодовый ответ
   * @param {string} answer - текстовый ответ
   */
  #serverHandlerError({code, answer}) {
    if (code < SuccessHTTPStatusRange.MIN || code > SuccessHTTPStatusRange.MAX) {
      this.#enableErrorAnswer(CodeTextContent.ERROR_TITLE, answer);
    }
  }

  /**
   * Проверяем состояние валидации и в зависимости от текущего состояния формы
   * показываем или скрываем не валидные поля ввода.
   *
   * Дополнительно проходит проверка, что меняется поле которое, относится к данному состоянию формы
   *
   * @param {Event} evt
   */
  onFormChange(evt) {
    const target = evt.target;

    if (this.#status === FormStatus.SEND_EMAIL) {
      if (!target.classList.contains(ClassName.EMAIL_INPUT)) return;

      if (this.#isMailValidated()) {
        this.#hideMailError();
      } else {
        this.#showMailError();
      }
      return;
    }

    if (this.#status === FormStatus.SEND_CODE) {
      if (!target.closest(Selector.DIGITS_WRAPPER)) return;

      if (this.#digitInputView.isValid) {
        this.#hideDigitWrapperError();
      } else {
        this.#showDigitWrapperError();
      }
    }
  }

  /**
   * При наведении на кнопку в зависимости от текущего состояния формы
   * показываем не валидные поля ввода
   */
  onSubmitButtonMouseover() {
    if (this.#status === FormStatus.SEND_EMAIL) {
      if (this.#isMailValidated()) return;
      this.#showMailError();
      return;
    }

    if (this.#status === FormStatus.SEND_CODE) {
      if (this.#digitInputView.isValid) return;
      this.#showDigitWrapperError();
    }
  }

  async onFormSubmit(evt) {
    evt.preventDefault();

    if (this.#status === FormStatus.SEND_EMAIL) {
      if (!this.#isMailValidated()) return;

      const res = await this.#customFetch.customQuery(this.#actionUrl, {method: Method.POST, query: this.#getFormData()})
        .catch(this.#errorHandler);

      if (!res) return;

      if (res.code === 200) {
        this.#status = FormStatus.SEND_CODE;
        this.#changeSubmitButtonTitle();
        this.#showDigitsWrapper();
        this.#hideEmailInput();
        this.#changeTextContent(CodeTextContent.TITLE, CodeTextContent.TEXT);
        this.#enableSendCode();
      }

      this.#serverHandlerError(res);
    }

    if (this.#status === FormStatus.SEND_CODE || this.#status === FormStatus.CODE_ERROR) {
      if (!this.#digitInputView.isValid) return;

      this.#digitInputView.disabledInput();
      const res = await this.#customFetch.customQuery(`${this.#actionUrl}?verification=1`, {
        method: Method.POST,
        query: this.#getFormData(true),
      })
        .catch(this.#errorHandler);

      if (!res) return;

      if (res.code === 200) {
        this.#hideForm();
        this.#enableSuccessAnswer(CodeTextContent.SUCCESS_TITLE, CodeTextContent.SUCCESS_TEXT);
        return;
      }

      if (res.code === 203) {
        this.#status = FormStatus.CODE_ERROR;
        this.#digitInputView.enableInput();
        this.#changeSubmitButtonTitle();
        this.#enableErrorAnswer(CodeTextContent.ERROR_TITLE, CodeTextContent.WRONG_CODE);
        return;
      }

      this.#serverHandlerError(res);
    }
  }
}


export {StockForm}
